/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import './StartOverModal.scss';
import { TuxModal } from '@tuxedo/react-component-library';
import {ExdsTheme} from "@exds/theme";
import {ExdsButton} from "@exds/core";
import React from "react";

export default function StartOverModal(props) {
  const {isStartOverModalOpen, setIsStartOverModalOpen} = props;

  const handleStartOverClick = () => {
    setIsStartOverModalOpen(false);
    window.open('/validateIdentity', '_self');
  };

  const handleCancelClick = () => {
    setIsStartOverModalOpen(false);
  };

  return (
    <TuxModal
      className="modal-container"
      type='popup'
      open={isStartOverModalOpen}
      onCloseModal={() => setIsStartOverModalOpen(false)}
      title="Are you sure you want to start over?"
      body={
        <ExdsTheme>
          <p>
            You will need to start again from the beginning if you haven't created your password and security questions.
          </p>
        </ExdsTheme>
      }
      footer={
        <ExdsTheme>
          <ExdsButton
            text="Yes, I want to start over"
            variant="secondary"
            onClick={handleStartOverClick}
          />
          <ExdsButton
            text="No, let's continue"
            variant="primary"
            onClick={handleCancelClick}
          />
        </ExdsTheme>
      }
    />
  );
}
